module.exports = __webpack_public_path__ + "static/img/2.1f1dc07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/2.png
// module id = RWhX
// module chunks = 0